import React, { PropTypes } from 'react';
import Spinner from 'react-spinkit';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as types from '../constants/actionTypes';

class Overlay extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            active : this.props.pageState.request.overlay,
            message : this.props.pageState.runscript
        };

        this.exitOverlay = this.exitOverlay.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.state = {
            ...this.state,
            active : newProps.pageState.request.overlay,
            message: newProps.pageState.runscript
        };
    }

    exitOverlay() {
        const { dispatch } = this.props,
            { assignment } = this.props.pageState
        ;

        dispatch({
            type: types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED,
            payload: {
                assignmentName: assignment.name,
                dropboxName: assignment.dropbox.name
            }
        });

        dispatch({
            type: types.EXIT__OVERLAY__REQUESTED,
            payload: {}
        });
    }

    render() {
        return (
            <div>
            {this.state.active
                ?
                (
                <span>
                    <button onClick={this.exitOverlay} className="overlay-exit" type="button">Exit</button>
                    <span className="overlay-window">
                        {(this.state.message.runscript).length > 0
                            ? <div className="overlay-window-content">
                            <span className="overlay-window-message"><pre>{this.state.message.runscript}</pre></span>
                        </div>
                            : (<Spinner spinnerName="three-bounce" className="spinner-overlay spinner-window overlay-window-content" noFadeIn/>)
                        }
                    </span>
                </span>
                )
                : null
            }
            </div>
        );
    }

}
Overlay.propTypes = {
    dispatch: PropTypes.func.isRequired,
    pageState: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        pageState: state
    };
}

export default connect(mapStateToProps)(withRouter(Overlay));



/** WEBPACK FOOTER **
 ** ./src/components/Overlay.js
 **/